var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.626 8.26235e-05C12.3789 0.0541739 15.4579 3.48248 17 6.43226C17 6.43226 16.4573 7.5606 15.9484 8.2829C15.7021 8.63233 15.443 8.97275 15.1707 9.30198C14.9766 9.53638 14.7761 9.76464 14.5681 9.98642C12.7094 11.9698 10.04 13.4493 7.22122 12.8749C4.08975 12.2366 1.53539 9.51041 0 6.57831C0 6.57831 0.545159 5.44888 1.05695 4.72766C1.28623 4.4042 1.52687 4.08939 1.77886 3.78395C1.97194 3.54991 2.17212 3.32165 2.37903 3.09987C4.02125 1.34155 6.12842 -0.0121781 8.626 8.26235e-05ZM8.61287 1.44252C6.52238 1.43458 4.78398 2.62063 3.40866 4.09299C3.22162 4.29313 3.04132 4.4994 2.8667 4.71071C2.63706 4.9891 2.41772 5.27651 2.20867 5.57113C1.99962 5.86538 1.78525 6.23681 1.61525 6.55234C2.96891 8.86348 5.00083 10.951 7.50054 11.4606C9.82989 11.9355 12.0038 10.6308 13.5399 8.99186C13.7276 8.79172 13.909 8.58509 14.0843 8.37342C14.3328 8.07303 14.5691 7.76255 14.7938 7.44341C15.0018 7.14807 15.2158 6.77592 15.3855 6.46003C13.9807 4.07099 11.5772 1.4894 8.61287 1.44252Z",
    fill: "#9A9DA0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50019 3.61426C10.0707 3.61426 11.3459 4.90992 11.3459 6.50526C11.3459 8.10095 10.0707 9.39626 8.50019 9.39626C6.93002 9.39626 5.65479 8.10095 5.65479 6.50526C5.65479 4.90992 6.93002 3.61426 8.50019 3.61426Z",
    fill: "#9A9DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.1c3a5ec02a05a047f31d4abccda1dd08.svg";
export { ForwardRef as ReactComponent };